<template>
    <div class="modal fade" ref="modal" :id="id" tabindex="-1" role="dialog" style="z-index:10000">
        <div class="modal-dialog" role="document" :class="modalDialogClass">
            <div class="modal-content">
                <!--<div class="row" style="overflow: hidden">-->
                    <!--<div class="col-md-12" style="padding:0">-->
                        <!--<h2 style="padding: 0 30px" class="modaltitleHeader">{{title}}</h2>-->
                    <!--</div>-->
                <!--</div>-->
                <div class="modal-header">
                    <h5 class="modal-title"><i class="fa fa-search me-1"></i>
                        <span class="modalTitleIn">{{title}}</span>
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <np-preloader v-if="loading" style="margin:0"></np-preloader>
                <div class="modal-body">
                    <div class="panel-sub-heading headingSmall" v-if="subtitle">
                        <span class="markedBottom">{{subtitle}}</span>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <slot></slot>
                        </div>
                        <div class="col-12">
                            <small class="invalid-small" style="color:red">{{error}}</small>
                        </div>
                    </div>
                </div>
                <div v-if="mode === 'view-only'" class="modal-footer">
                    <a class="btn btn-default" @click="cancel">{{lang('ok')}}</a>
                </div>
                <div v-else-if="mode === 'custom'">
                    <slot name="footer"></slot>
                </div>
                <div v-else class="modal-footer">
                    <a class="btn btn-danger" @click="cancel">{{lang('cancel')}}</a>
                    <a class="btn btn-default" @click="confirm" :disabled="submitting">{{lang('save')}} <i class="fa fa-spinner fa-spin" :class="{displayNone: !submitting}" ></i> </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'np-modal',
        props: {
            id:{},
            title: {},
            subtitle: {},
            value: {},
            mode: String, //default mode: send ajax form. 'view-only' mode: pop up view only message
            url: {},
            loading: Boolean,
            modalDialogClass: String
        },
        data: function () {
            return {
                error: '',
                submitting: false,
            }
        },
        methods: {
            cancel: function() {
                $(this.$refs.modal).modal('hide');
            },
            confirm: function() {
                const vm = this;
                const data = this.value;
                this.submitting = true;
                this.getAxiosInstance().post(vm.url, data)
                    .then(function (response) {
                        const data = response.data;
                        if (data.result.toLowerCase() === 'error' ) {
                            const msg = data.error.explanation;
                            vm.error = msg;
                            vm.$emit('error', msg);
                        } else {
                            vm.error = '';
                            vm.$emit('success', data);
                        }
                        vm.submitting = false;
                    })
                    .catch(function(error){
                        vm.error = 'Unknown error.'
                        vm.$emit('error', error);
                        vm.submitting = false;
                        console.error(error);
                    })
                    .finally(function(){
                        //note: Edge doesn't support finally
                        vm.submitting = false;
                    });
            },
            show: function () {
                $(`#${this.id}`).modal('show');
              // let modalEl = document.querySelector(`#${this.id}`)
              // let modal = bootstrap.Modal.getOrCreateInstance(modalEl)
              // modal.show();
            },
            hide: function () {
                console.log('hide')
               $(`#${this.id}`).modal('hide');
              // let modalEl = document.querySelector(`#${this.id}`)
              // let modal = bootstrap.Modal.getOrCreateInstance(modalEl)
              // modal.hide();
            }
        }

    };
</script>

<style scoped>

</style>
